module.exports = __webpack_public_path__ + "static/media/21.3798ae4e.png";